import autobind from 'autobind-decorator';
import { extendObservable, computed } from 'mobx';

@autobind
class BaseballMatchPlayerStatModel {
  vsName;

  constructor(data, vsName) {
    extendObservable(this, data);

    this.vsName = vsName;
  }

  @computed
  get chart() {
    const { starterPitcingStat } = this;

    let result = {
      era: { p: 0, v: '' },
      whip: { p: 0, v: '' },
      hitAvg: { p: 0, v: '' },
      so9: { p: 0, v: '' },
      bb: { p: 0, v: '', isNpb: false }
    };

    // TODO: NPB는 볼넷 데이터가 없음 사사구로 표현해야함 pitBb가 0이면 NPB로 알고 데이터 변경함

    // 볼넷 -                 pitBb: 26
    // 사사구 -               pitBbhp: 30
    // 평균자책점 -           pitEra: 3.92308
    // 경기수 -               pitGp: 15
    // 피안타 -               pitHit: 74
    // 아웃카운트             pitIp2: 234
    // 패 -                   pitLoss: 3
    // 퀄리티 스타트 -        pitQs: 4
    // 삼진 -                 pitSo: 83
    // whip 이닝당 출루허용 - pitWhip: 1.28205
    // 승 -                   pitWin: 7

    // 평균 자책점  - 7을 기준으로 7이상일 경우 100% 고정 (낮은숫자가 빨간색)
    // whip         - 3을 기준으로 3이상일 경우 100% 고정 (낮은숫자가 빨간색)
    // 피안타율     - 1이 100% (낮은숫자가 빨간색)
    // 9이닝당 삼진 - 10을 기준으로 10이상일 경우 100% 고정 (높은게 빨간색)
    // 경기당 볼넷  - 5를 기준으로 5이상일 경우 100% 고정 (낮은숫자가 빨간색)

    // 경기당 피안타 - 피안타(pitHit) /  경기수(pitGp)
    // 소수점 2자리까지 표시, 3자리에서 반올림
    // 10을 기준으로 10이상일 경우 100% 고정 (낮은게 빨간색)

    // 9이닝당 삼진 - 삼진(pitSo)/아웃카운트*3*9
    // 소수점 2자리까지 표시, 3자리에서 반올림
    // 10을 기준으로 10이상일 경우 100% 고정 (높은게 빨간색)

    // 경기당 볼넷  - 볼넷/경기수
    // 소수점 2자리까지 표시, 3자리에서 반올림
    // 5를 기준으로 5이상일 경우 100% 고정 (낮은숫자가 빨간색)

    // debugger;

    if (!!starterPitcingStat) {
      // 평균 자책점
      if (starterPitcingStat.pitEra > 0) {
        const era = (starterPitcingStat.pitEra / 7) * 100;
        const eraP = +era.toFixed(1);

        result.era = {
          p: eraP > 100 ? 100 : eraP,
          v: starterPitcingStat.pitEra.toFixed(2)
        };
      }

      //  whip
      if (starterPitcingStat.pitWhip > 0) {
        const whip = (starterPitcingStat.pitWhip / 3) * 100;
        const whipP = +whip.toFixed(1);

        result.whip = {
          p: whipP > 100 ? 100 : whipP,
          v: starterPitcingStat.pitWhip.toFixed(2)
        };
      }

      // 경기당 피안타
      if (starterPitcingStat.pitSo > 0 && starterPitcingStat.pitGp > 0) {
        const hg = starterPitcingStat.pitHit / starterPitcingStat.pitGp;
        const hitAvg = (hg / 10) * 100;
        const hitAvgP = +hitAvg.toFixed(1);

        result.hitAvg = {
          p: hitAvgP > 100 ? 100 : hitAvgP,
          v: `${hg.toFixed(2)} (${starterPitcingStat.pitHit})`
        };
      }

      // 9이닝당 삼진
      if (starterPitcingStat.pitHit > 0 && starterPitcingStat.pitIp2 > 0) {
        const si = starterPitcingStat.pitSo / starterPitcingStat.pitIp2;
        const so9 = ((si * 3 * 9) / 10) * 100;
        const so9P = +so9.toFixed(1);

        result.so9 = {
          p: so9P > 100 ? 100 : so9P,
          v: `${(si * 3 * 9).toFixed(2)} (${starterPitcingStat.pitSo})`
        };
      }

      //  경기당 볼넷
      if (starterPitcingStat.pitBb > 0 && starterPitcingStat.pitGp > 0) {
        const bg = starterPitcingStat.pitBb / starterPitcingStat.pitGp;
        const bb = (bg / 5) * 100;
        const bbP = +bb.toFixed(1);

        result.bb = {
          ...result.bb,
          p: bbP > 100 ? 100 : bbP,
          v: `${bg.toFixed(2)} (${starterPitcingStat.pitBb})`
        };
      }

      if (
        starterPitcingStat.pitBb === 0 &&
        starterPitcingStat.pitBbhp > 0 &&
        starterPitcingStat.pitGp > 0
      ) {
        const bg = starterPitcingStat.pitBbhp / starterPitcingStat.pitGp;
        const bb = (bg / 5) * 100;
        const bbP = +bb.toFixed(1);

        result.bb = {
          p: bbP > 100 ? 100 : bbP,
          v: `${bg.toFixed(2)} (${starterPitcingStat.pitBbhp})`,
          isNpb: true
        };
      }
    }

    return result;
  }

  @computed
  get player() {
    const { starterPitcingStat, vsName } = this;

    let result = {
      name: '미정',
      visible: false,
      noDataWlq: '선발투수가 확정되면',
      noDataVs: '업데이트 됩니다',
      wlq: '0승 0패 QS 0',
      vs: `vs ${vsName} 시즌 전적 없음`
    };

    if (!!starterPitcingStat && !!starterPitcingStat.player) {
      const { player } = starterPitcingStat;

      result.visible = true;
      result.name = player.displayName;
      result.wlq = `${starterPitcingStat.pitWin}승 ${starterPitcingStat.pitLoss}패 QS ${starterPitcingStat.pitQs}`;

      if (!!starterPitcingStat.vsStat) {
        result.vs = `vs ${vsName} ${starterPitcingStat.vsStat.pitWin}승 ${
          starterPitcingStat.vsStat.pitLoss
        }패 평균자책 ${starterPitcingStat.vsStat.pitEra.toFixed(2)}`;
      }
    }

    return result;
  }

  @computed
  get seasonBatList() {
    const { seasonBattingStats } = this;

    if (seasonBattingStats.length > 0) {
      return seasonBattingStats
        .sort((a, b) => {
          if (a.batHit > b.batHit) return -1;
          if (a.batHit < b.batHit) return 1;
          else return 0;
        })
        .slice(0, 10);
    } else {
      return [];
    }
  }

  @computed
  get seasonVsBatList() {
    const { seasonVsBattingStats } = this;

    if (seasonVsBattingStats.length > 0) {
      return seasonVsBattingStats
        .sort((a, b) => {
          if (a.batHit > b.batHit) return -1;
          if (a.batHit < b.batHit) return 1;
          else return 0;
        })
        .slice(0, 10);
    } else {
      return [];
    }
  }
}

export default BaseballMatchPlayerStatModel;
